import { amplitudeLogSaasEvent, trackMpEvent } from '@/helpers';
import { Place } from '@/types/state/shared';
import { EVENT_NAME, SCREEN_NAME, SIGN_UP_STARTING_POINT, UNVERIFIED_SUBSCRIPTION_TYPE } from '../constants/tracking';
import { StartingPoint } from '../types/tracking';

export const getCompanyTrackingProps = (
  {
    id,
    name,
    screen,
    subType,
    step,
    startingPoint,
    selectedPlan,
  }: {
    id?: number;
    name?: string;
    screen: string;
    subType?: string;
    step?: string;
    startingPoint?: StartingPoint;
    selectedPlan?: string;
  },
  isSaasEvent?: boolean,
) => {
  return {
    ...(isSaasEvent ? { mp_place_id: id, mp_company_name: name } : { place_id: id, company_name: name }),
    screen_name: screen,
    company_subscription_type: subType,
    sign_up_step: step,
    sign_up_starting_point: startingPoint,
    selected_plan: selectedPlan,
  };
};

export const sendStartedSignupFlowTracking = (startingPoint: StartingPoint, place: Place) => {
  trackMpEvent(
    EVENT_NAME.PROFILE_PAGE_SIGN_UP_FLOW,
    {
      ...getCompanyTrackingProps({
        id: place.id,
        name: place.about?.name,
        screen: SCREEN_NAME.COMPANY_DETAILS,
        startingPoint: startingPoint,
        step: SIGN_UP_STARTING_POINT,
        subType: UNVERIFIED_SUBSCRIPTION_TYPE,
      }),
    },
    false,
  );
  amplitudeLogSaasEvent(EVENT_NAME.PROFILE_PAGE_SIGN_UP_FLOW, {
    ...getCompanyTrackingProps(
      {
        id: place.id,
        name: place.about?.name,
        screen: SCREEN_NAME.COMPANY_DETAILS,
        startingPoint: startingPoint,
        step: SIGN_UP_STARTING_POINT,
        subType: UNVERIFIED_SUBSCRIPTION_TYPE,
      },
      true,
    ),
  });
};
